import { AuthGuard } from '../../../shared/services';
import { StudentsForImpactDetailsComponent } from './students-for-impact-details.component';
import { StudentsForImpactDetailsResolver } from './students-for-impact-details.resolver';
import { Route } from '@angular/router';

export const StudentsForImpactDetailsRoutes: Route[] = [
  {
    path: 'details/:id',
    component: StudentsForImpactDetailsComponent,
    canActivate: [AuthGuard],
    resolve: {
      user: StudentsForImpactDetailsResolver
    }
  }
];
